<script lang="ts" setup>
import { ref, onMounted } from 'vue';

</script>



<template>
    <div>
    <router-view></router-view>
    </div>
</template>